const RECAPTCHA_SITEKEY = '6LdAAXgUAAAAAF4SGaUBUb360KEclFkQDCm4Lyj2'

export const renderRecaptcha = (container, callback, type = 'image', size = 'invisible', position = 'bottomright') => {
  if (!container || !callback ) return;
  
  const recaptchaConfig = {
    sitekey: RECAPTCHA_SITEKEY,
    badge: position,
    type,
    size,
    callback
  };

  if (window.grecaptcha?.render) {
    window.grecaptcha.render(container, recaptchaConfig);
  } else {
    document.addEventListener('recaptcha:loaded', () => { window.grecaptcha.render(container, recaptchaConfig)});
  }  
};

export const executeRecaptcha = () => window.grecaptcha.execute()